import { api } from '../index';

export const subscribe = data => api.post('/subscription', data);
export const getSubscriptionsList = () => api.get('/billing-plan');
